var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{staticClass:"starNo"},[_vm._v(_vm._s(_vm.number))]),(_vm.star)?_c('b-icon',{staticStyle:{"color":"gold"},attrs:{"icon":"star-fill","font-scale":"2"}}):_vm._e(),(_vm.plus)?_c('b-icon',{attrs:{"icon":"plus","font-scale":"1.8"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }